"use client";
//#region packages/@mantine/core/src/components/Drawer/Drawer.module.css
var Drawer_module_default = {
	"root": "m_f11b401e",
	"header": "m_5a7c2c9",
	"content": "m_b8a05bbd",
	"inner": "m_31cd769a"
};
//#endregion
export { Drawer_module_default as default };

//# sourceMappingURL=Drawer.module.mjs.map